<script lang="ts">
  import { api, navigate, type Me } from '../lib/api';
  import type { PositionConfig } from '../../../shared/src/types';

  let { principal, onlogout }: { principal: NonNullable<Me['principal']>; onlogout: () => void } = $props();
  type Pos = PositionConfig & { occupied: number; sourceName: string | null };
  let positions = $state<Pos[]>([]);
  let error = $state<string | null>(null);

  async function load() {
    try {
      positions = await api.get<Pos[]>('/api/positions');
      if (principal.kind === 'token') {
        const mine = positions.find((p) => p.id === principal.positionId);
        if (mine) navigate(`/cam/${mine.number}`, true);
      }
    } catch (err) {
      error = (err as Error).message;
    }
  }
  void load();
  const timer = setInterval(load, 3000);
  $effect(() => () => clearInterval(timer));

  async function logout() {
    await api.post('/api/logout');
    onlogout();
  }
</script>

<div class="page">
  <div class="row head">
    <h1 class="grow">Choose your camera</h1>
    <span class="muted">{principal.name} · {principal.role}</span>
    {#if principal.role === 'director' || principal.role === 'admin'}
      <button onclick={() => navigate('/director')}>Director panel</button>
    {/if}
    {#if principal.role === 'admin'}<button onclick={() => navigate('/admin')}>Admin</button>{/if}
    <button onclick={logout}>Log out</button>
  </div>
  {#if error}<p class="error">{error}</p>{/if}
  <div class="grid">
    {#each positions as p (p.id)}
      <button class="pos" class:busy={p.occupied > 0} disabled={p.exclusive && p.occupied > 0} onclick={() => navigate(`/cam/${p.number}`)}>
        <span class="num">{p.number}</span>
        <span class="name">{p.name}</span>
        <span class="muted">{p.sourceName ?? 'no return feed'}</span>
        <span class="occ">{p.occupied > 0 ? `${p.occupied} connected${p.exclusive ? ' · in use' : ''}` : 'free'}</span>
      </button>
    {/each}
  </div>
  {#if positions.length === 0 && !error}<p class="muted">No camera positions configured yet.</p>{/if}
</div>

<style>
  .head { margin-bottom: 16px; }
  .head h1 { margin: 0; }
  .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 12px; }
  .pos { display: flex; flex-direction: column; align-items: flex-start; gap: 4px; padding: 18px; text-align: left; min-height: 130px; }
  .num { font-size: 2.4rem; font-weight: 800; line-height: 1; }
  .name { font-size: 1.15rem; font-weight: 700; }
  .occ { margin-top: auto; font-size: 0.85rem; color: var(--preview); }
  .busy .occ { color: var(--warn); }
</style>
